import * as React from 'react';
import EmptyStateComponent from '../../../EmptyState/EmptyState';
import folderIcon from '../../../../assets/icons/folder.png';
import { ReactComponent as NotSortedIcon } from '../../../../assets/icons/table/column-unsorted.svg';
import { ReactComponent as SortUpIcon } from '../../../../assets/icons/table/column-sort-up.svg';
import { ReactComponent as SortDownIcon } from '../../../../assets/icons/table/column-sort-down.svg';



function ColumnUnsortedIcon() {
    return <NotSortedIcon/>;
}

function ColumnSortedAscendingIcon() {
    return <SortUpIcon/>;
}

function ColumnSortedDescendingIcon() {
    return <SortDownIcon/>;
}

export const getDataGridCommonProps = (emptyStateText: string) => {

    function NoRowsOverlay() {
        return <EmptyStateComponent text={emptyStateText} icon={<img src={folderIcon} alt={emptyStateText}/>}/>
    }

    return ({
        disableColumnMenu: true,
        slots: {
            noRowsOverlay: NoRowsOverlay,
            columnUnsortedIcon: ColumnUnsortedIcon,
            columnSortedDescendingIcon: ColumnSortedDescendingIcon,
            columnSortedAscendingIcon: ColumnSortedAscendingIcon
        }
    });
}
